export default __webpack_public_path__ + "static/media/Matthew1.e096bd5c.png";